import { useCallback } from "react";
import { Button } from "../../../../externalComponents/tailwind/button";
import { Dialog, DialogActions, DialogBody, DialogTitle } from "../../../../externalComponents/tailwind/dialog";
import { Text } from "../../../../externalComponents/tailwind/text";

const AlreadyScheduledDialog = ({ modalRef, setModalRef, data, onKeepGoing }) => {
  const handleClose = useCallback(() => {
    setModalRef((_modalRef) => ({
      ..._modalRef,
      alreadyScheduled: false,
    }));
  }, []);

  const handleKeepGoing = useCallback(() => {
    handleClose();
    onKeepGoing();
  }, [handleClose, onKeepGoing]);

  return (
    <Dialog open={modalRef.alreadyScheduled} onClose={handleClose}>
      <DialogTitle>⚠️ This campaign is already scheduled</DialogTitle>
      <DialogBody>
        <Text className="text-md">
          {`${data?.name} is scheduled. If you reschedule, both batches will be sent. You might want to cancel scheduled messages first.`}
        </Text>
      </DialogBody>
      <DialogActions>
        <Button
          color="secondaryButton"
          className="min-w-[100px] h-10"
          onClick={handleClose}
        >
          Cancel
        </Button>
        <Button
          color="primaryButton"
          className="min-w-[100px] h-10"
          onClick={handleKeepGoing}
        >
          Schedule again
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default AlreadyScheduledDialog;
